import { c as _c } from "react/compiler-runtime";
import { ApiWave } from "@/generated/models/ApiWave";
export default function WaveHeaderNameEditInput(t0) {
  const $ = _c(6);
  const {
    name,
    setName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <label htmlFor="name" className="tw-block tw-text-sm tw-font-semibold tw-leading-5 tw-text-iron-300">Wave name</label>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== setName) {
    t2 = e => setName(e.target.value);
    $[1] = setName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== name || $[4] !== t2) {
    t3 = <div>{t1}<div className="tw-mt-2 tw-relative"><input type="text" name="name" required={true} autoComplete="off" value={name} onChange={t2} placeholder="Please select a name" className="tw-form-input tw-block tw-w-full tw-rounded-lg tw-border-0 tw-py-3 tw-px-3 tw-bg-iron-900 tw-text-iron-50 tw-font-normal tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 placeholder:tw-text-iron-400 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 hover:tw-ring-iron-600 tw-text-base tw-transition tw-duration-300 tw-ease-out" /></div></div>;
    $[3] = name;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}